// extracted by mini-css-extract-plugin
export default {"root":"LeaseTermHeader_root__MwGUr","toggle":"LeaseTermHeader_toggle__HvtDi","option":"LeaseTermHeader_option__z3I1k","active":"LeaseTermHeader_active__0nLAm"};